import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/ai-agents/{agentId}']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const updateAiAgent = async ({ agentId, creatorId, questionnaireTemplateId, ...body }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/ai-agents/{agentId}', { agentId, creatorId, questionnaireTemplateId });
  const data = await formsBackendClient.put(path, body);
  return data.data;
};

export default updateAiAgent;
